module.exports = __webpack_public_path__ + "static/img_9846-8c057b1004ce824903ceadd6de0f2809.webp";